// src/MoneyPaper.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var MoneyPaper_default = createIcon({
  displayName: "MoneyPaper",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.625 3.01067C19.4964 2.99178 19.3623 2.9974 19.2285 3.03215L3.99023 7.0009H11.9277L17.8848 5.45012C18.1378 5.82212 18.5432 6.06151 18.9922 6.10051L19.2285 7.0009H21.2949L20.4473 3.74895C20.343 3.34845 20.0108 3.06734 19.625 3.01067ZM3 9.0009C2.44774 9.00096 2.00006 9.44864 2 10.0009V20.0009C2.00006 20.5532 2.44774 21.0008 3 21.0009H21C21.5523 21.0008 21.9999 20.5532 22 20.0009V10.0009C21.9999 9.44864 21.5523 9.00096 21 9.0009H3ZM4.91211 11.0009H19.0879C19.239 11.4268 19.5741 11.7619 20 11.913V18.0888C19.5741 18.2399 19.239 18.575 19.0879 19.0009H4.91211C4.761 18.575 4.42591 18.2399 4 18.0888V11.913C4.42591 11.7619 4.761 11.4268 4.91211 11.0009ZM12 12.0009C10.3431 12.0009 9 13.344 9 15.0009C9 16.6578 10.3431 18.0009 12 18.0009C13.6569 18.0009 15 16.6578 15 15.0009C15 13.344 13.6569 12.0009 12 12.0009ZM7 14.0009C6.448 14.0009 6 14.4479 6 15.0009C6 15.5539 6.448 16.0009 7 16.0009C7.552 16.0009 8 15.5539 8 15.0009C8 14.4479 7.552 14.0009 7 14.0009ZM17 14.0009C16.448 14.0009 16 14.4479 16 15.0009C16 15.5539 16.448 16.0009 17 16.0009C17.552 16.0009 18 15.5539 18 15.0009C18 14.4479 17.552 14.0009 17 14.0009Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  MoneyPaper_default
};
